export var ConductionMethod;
(function (ConductionMethod) {
    ConductionMethod["Default"] = "";
    ConductionMethod["OwnerAccount"] = "owner-account";
})(ConductionMethod || (ConductionMethod = {}));
//# sourceMappingURL=conduction-method.js.map